import {gql} from 'apollo-angular';

export const GET_ALL_INTEREST_FIELDS = gql`
  query GetAllInterestFields {
    interestFields {
      id
      interestName
      subHeading
      countJobs
      countSchools
      countProviders
    }
  },
`;
